import { createContext, useContext, useEffect, useState, useCallback } from "react";

const ViewModeContext = createContext(null);
const STORAGE_KEY = "pt_view_mode"; // "auto" | "mobile" | "desktop"
const BREAKPOINT = 1024;

export function ViewModeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem(STORAGE_KEY) || "auto");
  const [width, setWidth] = useState(() => (typeof window !== "undefined" ? window.innerWidth : BREAKPOINT));

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, mode);
  }, [mode]);

  const isMobile = mode === "auto" ? width < BREAKPOINT : mode === "mobile";

  // Bascule explicite entre les deux vues (part de l'état effectif courant).
  const toggle = useCallback(() => {
    setMode(isMobile ? "desktop" : "mobile");
  }, [isMobile]);

  return (
    <ViewModeContext.Provider value={{ mode, setMode, isMobile, toggle }}>
      {children}
    </ViewModeContext.Provider>
  );
}

export function useViewMode() {
  const ctx = useContext(ViewModeContext);
  if (!ctx) return { mode: "auto", setMode: () => {}, isMobile: false, toggle: () => {} };
  return ctx;
}
